import { createAction } from "redux-actions";
import humps from "humps";
import { apiGet } from "util/api";

import * as types from "./constants";

export const appDrawerToggle = createAction(types.APP_DRAWER_TOGGLE);
export const openErrorModal = createAction(types.ERROR_MODAL_OPEN);
export const closeErrorModal = createAction(types.ERROR_MODAL_CLOSE);
export const errorModalSetBody = createAction(types.ERROR_MODAL_SET_BODY);
export const setMode = createAction(types.APP_SET_MODE);
export const setRebuildStatus = createAction(types.APP_SET_REBUILD_STATUS);

// if theres an error in setting dev mode it should fail quietly
export const checkDevMode = () => async dispatch => {
  const mode = await apiGet("/mode")
    .then(stream => stream.text())
    .catch();

  if (mode) dispatch(setMode(mode));
};

export const checkRebuildStatus = () => async dispatch => {
  const rebuild = await apiGet("/api/rebuild_status")
    .then(res => res.json())
    .then(humps.camelizeKeys);

  if (rebuild) {
    dispatch(setRebuildStatus(rebuild[0]));
    return rebuild[0];
  }
};
